export default __webpack_public_path__ + "static/media/room-2Bed-twin.2eb17b4e.jpg";